export default __webpack_public_path__ + "static/media/8.397d0fd7.jpg";